// extracted by mini-css-extract-plugin
export default {"item":"draggable-ingredient_item__WOWjZ","drag":"draggable-ingredient_drag__G+FsI","dragging":"draggable-ingredient_dragging__W35cb"};